<template>
  <div class="user-wrap">
    <div class="user-wrap-con">
      <!-- 用户头像 -->
      <div class="user-avatar">
        <span class="" @click="Login()">
          <img class="user-avatar-pic" :src="userInfo.portrait" alt v-if="userInfo">
        </span>
        <p class="credit-text">
          <span v-if="islogin">{{userInfo.nickName || '未知'}}</span>
          <router-link to="/login" v-else><span>点击登陆</span></router-link>
        </p>
      </div>
      <!-- 订单，待付款，待发货，已发货 -->
      <div class="user-order-state">
        <ul class="order-state-wrap">
          <li>
            <router-link :to="{path: '/order-list', query: {id: userInfo._id,active:0}}">
              <span class="order-state-icon">
                <img src="@/assets/images/user-order-icon.png" alt>
              </span>
              <p class="order-state-p">我的订单</p>
            </router-link>    
          </li>
          <li >
            <router-link :to="{path: '/order-list', query: {id: userInfo._id,active:1}}">
              <span class="order-state-icon">
                <img src="@/assets/images/user-dfk-icon.png" alt>
              </span>
              <p class="order-state-p">待付款</p>
            </router-link>
          </li>
          <li >
            <router-link :to="{path: '/order-list', query: {id: userInfo._id,active:2}}">
              <span class="order-state-icon">
                <img src="@/assets/images/user-dfh-icon.png" alt>
              </span>
              <p class="order-state-p">待发货</p>
            </router-link>
          </li>
          <li >
            <router-link :to="{path: '/order-list', query: {id: userInfo._id,active:3}}">
              <span class="order-state-icon">
                <img src="@/assets/images/user-yfh-icon.png" alt>
              </span>
              <p class="order-state-p">已发货</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{path: '/order-list', query: {id: userInfo._id,active:4}}">
              <span class="order-state-icon">
                <img src="@/assets/images/nowok.png" alt>
              </span>
              <p class="order-state-p">已完成</p>
            </router-link>
          </li>
          <li @click="notOpen()">
            <span class="order-state-icon">
              <img src="@/assets/images/user-tkwq-icon.png" alt>
            </span>
            <p class="order-state-p">退款维权</p>
          </li>
        </ul>
      </div>
      <!-- 购物车，收货地址，账号设置 -->
      <ul class="user-skip-wrap">
        <!-- 购物车 -->
        <li>
         <router-link to="/car">
            <span class="skip-icon">
              <img src="@/assets/images/user-car-icon.png" alt>
            </span>
            <p class="skip-p">购物车</p>
            <van-icon class="skip-arrow" name="arrow"/>
         </router-link>
        </li>
        <!-- 收货地址 -->
        <li @click="notOpen()">
<!--          <router-link to="/receiving-addr">-->
            <span class="skip-icon">
              <img src="@/assets/images/user-addr-icon.png" alt>
            </span>
            <p class="skip-p">收货地址</p>
            <van-icon class="skip-arrow" name="arrow"/>
<!--          </router-link>-->
        </li>
        <!-- 个人设置 -->
        <li>
          <router-link :to="{path: '/personal-set' , query: {id: userInfo._id}}">
            <span class="skip-icon">
              <img src="@/assets/images/user-personal-icon.png" alt>
            </span>
            <p class="skip-p">个人资料</p>
            <van-icon class="skip-arrow" name="arrow"/>
          </router-link>
        </li>
        <!-- 账号设置 -->
        <li>
          <router-link :to="{path: '/account-set',query: {id: userInfo._id, name: userInfo.name}}">
            <span class="skip-icon">
              <img src="@/assets/images/user-setting-icon.png" alt>
            </span>
            <p class="skip-p">账号管理</p>
            <van-icon class="skip-arrow" name="arrow"/>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 引入公共footer -->
    <common-footer></common-footer>
  </div>
</template>
<script>
import CommonFooter from "@/components/footer";
export default {
  data() {
    return {
      userInfo: '',
      islogin: false
    };
  },
  components: {
    CommonFooter
  },
  activated() {
    if(localStorage.getItem('token')) {
      this.islogin = true;
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    } else {
      this.islogin = false;
      this.userInfo = {}
    }
  },
  methods: {
    Login() {
      if(!this.islogin) {
        this.$router.push({
          name: 'login'
        })
      }
    },
    notOpen() {
      this.$toast('功能暂未开放，请耐心等待哦 ~.~');
    }
  }
};
</script>
<style lang="scss" scoped>
.user-wrap {
  padding-bottom: 120px;
  .header-wrap {
    background: $bg03;
  }
  /*用户头像*/
  .user-avatar {
    width: 100%;
    height: auto;
    background: $bg03;
    text-align: center;
    line-height: 1;
    overflow: hidden;
    padding-top: 88px;
    >span{
      width: 158px;
      height: 158px;
      margin: 0 auto;
      border-radius: 50%;
      overflow: hidden;
      display: inline-block;
      background: url(../../../assets/images/no-login.png) no-repeat;
      background-size: 100% 100%;
    }
    .user-avatar-pic {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .credit-text{
      font-size: 30px;
      color: $fc03;
      margin: 20px auto 40px;
    }
  }
  /*订单，待付款，待发货，已发货*/
  .user-order-state {
    width: 100%;
    height: 100px;
    background: $bg03;
    padding: 0 30px;
    box-sizing: border-box;
    .order-state-wrap {
      width: 100%;
      height: auto;
      // height: 258px;
      padding: 0 0 30px;
      background: $fc02;
      border-radius: $br30;
      z-index: 999;
      position: relative;
      box-shadow: $box-shadow1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      li {
        width: 172px;
        height: auto;
        text-align: center;
        line-height: 1;
        .order-state-icon {
          width: 44px;
          height: 44px;
          display: inline-block;
          margin-top: 28px;
          img {
            width: 100%;
          }
        }
        .order-state-p {
          font-size: 24px;
          color: $fc06;
          margin-top: 15px;
        }
      }
    }
  }
  /* 购物车，收货地址，账号设置 */
  .user-skip-wrap {
    width: 100%;
    height: auto;
    padding: 190px 30px 0;
    box-sizing: border-box;
    li {
      width: 100%;
      height: 88px;
      background: $fc02;
      border-radius: $br20;
      box-shadow: $box-shadow1;
      padding: 0 20px 0 30px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      a {
        width: 100%;
        height: 100%;
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .skip-icon {
        width: 44px;
        height: 44px;
        display: inline-block;
        margin-right: 24px;
        img {
          width: 100%;
        }
      }
      .skip-p {
        font-size: 28px;
        color: $fc06;
        flex: 1;
        text-align: left;
      }
      .skip-arrow {
        font-size: 38px;
        color: $fc01;
        font-weight: 600;
      }
      &:last-of-type {
        margin-bottom: 0;
      }
      &:active {
        .skip-arrow {
          color: $fc07;
        }
      }
    }
  }
}
</style>


